import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useProctorGroups } from '@indeed/frontend-proctor-utils';
import { DqPastAnswersPage } from './DqPastAnswersPage';
import { SqPastAnswersPage } from './SqPastAnswersPage';

export { useShouldIncludeHostedSQ } from './SqPastAnswersPage';

/** Selects the SQ or DQ data source while both reuse the same Past Answers UI. */
const PastAnswersPage: React.FC = () => {
    const [searchParams] = useSearchParams();
    const { getGroup } = useProctorGroups();
    const isDqPageEnabled =
        getGroup('rnhp_auto_apply_banner_tst')?.value === 2 &&
        getGroup('ia_dq_questions_prefill_tst')?.value === 1;

    return searchParams.get('questionType') === 'dq' && isDqPageEnabled ? (
        <DqPastAnswersPage />
    ) : (
        <SqPastAnswersPage />
    );
};

export default PastAnswersPage;
